import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  wrapper: {
    height: "fit-content",
    textDecoration: "none",
  },
}));
